// import AuthHeader from "@/components/AuthHeader";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { useForm } from "react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { forgotPassword as forgotPasswordApi } from "../api/auth";
import Footer from "@/components/Footer";
import  "../styles/globle.css";

interface ForgotPasswordFormData {
  email: string;
}

const ForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  
 const form = useForm<ForgotPasswordFormData>({
  defaultValues: {
    email: "",
  },
});

const {
  formState: { errors },
} = form;

  const location = useLocation();
  const error = location.state?.error;

  const onSubmit = async (data: ForgotPasswordFormData) => {
    setIsLoading(true);
    try {
      await forgotPasswordApi(data.email);
      setIsSubmitted(true);
    } catch (error) {
      console.error("Forgot password error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="flex items-center justify-center w-full px-4 pt-12 pb-24 md:pt-16 md:pb-32">
        <Card className="w-full max-w-md p-4 sm:p-6 lg:p-8 rounded-2xl shadow-sm">
          <CardContent className="pt-6 text-center">
            <div className="text-4xl mb-4">✉️</div>
            <h2 className="text-xl font-semibold mb-2">Check your email</h2>
            <p className="text-muted-foreground mb-6">
              We've sent a password reset link to your email address.
            </p>
            <Link to="/login">
              <Button variant="outline" className="w-full">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to login
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="forget-password-container" style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%', gap: '68px' }}>
      <div className="flex items-center justify-center w-full px-4 pt-12 pb-24 md:pt-16 md:pb-32">
      <Card className="w-full max-w-md p-4 sm:p-6 lg:p-8 rounded-2xl shadow-sm">
        <CardHeader className="text-center space-y-1">
          <CardTitle className="text-2xl font-bold">Reset your password</CardTitle>
        </CardHeader>
        <CardContent>
          {error && <div className="text-sm text-red-600 mb-4">{error}</div>}
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-5 mt-6">
              <FormField
                control={form.control}
                name="email"
                rules={{ 
                  required: "Please enter your email",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Please enter a valid email address"
                  }
                }}
                render={({ field }) => (
                  <FormItem>
                    <FormLabel
                      className={
                        errors.email && field.value
                          ? "text-red-600"
                          : "text-foreground"
                      }
                    >
                      Email address
                    </FormLabel>

                    <FormControl>
                      <Input
                        type="email"
                        placeholder="Enter your email"
                        {...field}
                        className={`
                          h-11 px-4 text-base border
                          focus-visible:ring-2 focus-visible:ring-blue-500
                          ${
                            errors.email && field.value
                              ? "border-red-500 focus-visible:ring-red-500"
                              : "border-gray-200"
                          }
                        `}
                      />   
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <Button
                type="submit"
                className="w-full h-11
                text-base font-medium rounded-lg
                mt-6
                bg-[#005FCC] hover:bg-[#0049A8]
                text-white
                transition-colors
                disabled:opacity-50"
                disabled={isLoading}
              >

                {isLoading ? "Sending..." : "Send Reset Link"}
              </Button>
            </form>
          </Form>

          <div className="mt-6">
            <Link 
              to="/login"
              className="flex items-center justify-center text-sm text-primary/80 hover:text-primary underline-offset-2"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to login
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
    <div className="footer-forget-password">
       
     
        <Footer />
   
    </div>
    </div>

    
  );
};

export default ForgotPassword;
